import styled from 'styled-components'

export const MainContainer = styled.div<{
  isClearable: boolean | undefined
  selected: any
  icon: string | undefined
  disabled?: boolean
}>`
  position: relative;
  max-width: 180px;

  .filter-icon {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    pointer-events: none;
    ${({ disabled }) => disabled && `opacity: 0.3;`}
  }
  .filter-input {
    width: 100%;
    height: 48px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    font-family: Inter;
    font-weight: 500;
    font-size: 14px;
    color: #757575;
    max-width: 180px;
    border: 1px solid
      ${({ disabled }) =>
        disabled ? '#CCCCCC' : 'var(--preto-principal, #1c1d22)'};
    border-radius: 5px;
    outline: none;
    /* Ajustando padding dinamicamente de acordo com o icone esquerdo */
    padding-left: ${({ icon }) => (icon ? '32px' : '12px')};
    /* Ajustando padding dinamicamente de acordo com o icone de clear */
    padding-right: ${({ isClearable, selected }) =>
      isClearable && selected ? '48px' : '28px'};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:disabled {
      opacity: 0.5;
    }
  }
  .chrevon-down {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    pointer-events: none;
    ${({ disabled }) => disabled && `opacity: 0.3;`}
  }
  .clear-btn {
    position: absolute;
    top: 50%;
    right: 28px;
    transform: translateY(-50%);
    padding: 5px;
    border: none;
    background: none;
    transition: opacity 0.2s;
    cursor: pointer;
  }
  .clear-btn:hover {
    opacity: 0.6;
  }
  .clear-icon {
    width: 10px;
    height: 10px;
  }
  .menu {
    position: absolute;
    top: 52px;
    left: 0;
    width: 100%;
    z-index: 999;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
  }
  .menu::-webkit-scrollbar {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
  .menu::-webkit-scrollbar-track {
    background: #fbfbfb;
    border: 0;
  }
  .menu::-webkit-scrollbar-thumb {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
`
export const Option = styled.button<{ isSelected: boolean }>`
  padding: 8px 10px;
  font-size: 12px;
  color: #1c1d22;
  font-weight: 500;
  background-color: #fff;
  border: none;
  outline: none;
  width: 100%;
  text-align: left;
  font-family: Inter;
  cursor: pointer;
  background-color: ${({ isSelected, theme }: any & { theme: any }) =>
    isSelected ? theme.colors.toggleHover : '#fff'};
  &:hover {
    background-color: ${({ isSelected, theme }: any & { theme: any }) =>
      isSelected ? theme.colors.toggleHover : theme.colors.toggleUnselected};
  }
`
